// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8k-4";
export var collapsed = "_8k-1";
export var headerBar = "_8k-0";
export var leftHeaderContent = "_8k-3";
export var subjectContainer = "_8k-2";